(function(){
  'use strict';

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initNewHCSwiper(){
    if (typeof Swiper === 'undefined') return;

    var nodes = document.querySelectorAll('[data-nhcswiper="true"] .swiper');
    if (!nodes.length) return;

    nodes.forEach(function(node){
      if (node.newHcSwiper) return;

      try {
        var optsContainer = node.closest('[data-nhcswiper="true"]');
        if (!optsContainer) return;

        var optsAttr = optsContainer.getAttribute('data-options');
        var base = {
          slidesPerView: 1,
          spaceBetween: 0,
          speed: prefersReducedMotion ? 0 : 300,
          breakpoints: {
            768: { slidesPerView: 2 },
            992: { slidesPerView: 4 }
          }
        };

        var extra = {
          loop: false,
          autoplay: false,
          pagination: false,
          navigation: true,
          hide_arrows_mobile: false
        };
        if (optsAttr && optsAttr.trim()) {
          try {
            var parsed = JSON.parse(optsAttr);
            if (parsed && typeof parsed === 'object') {
              extra.loop = parsed.loop === true;
              extra.pagination = parsed.pagination === true;
              extra.navigation = parsed.navigation !== false;
              extra.hide_arrows_mobile = parsed.hide_arrows_mobile === true;
              if (parsed.autoplay) {
                if (typeof parsed.autoplay === 'object' && typeof parsed.autoplay.delay === 'number') {
                  extra.autoplay = { delay: parsed.autoplay.delay };
                } else {
                  extra.autoplay = { delay: 4000 };
                }
              } else {
                extra.autoplay = false;
              }
            }
          } catch(e) {
            console.warn('[New HCS] Errore parsing data-options, uso valori di default', e);
          }
        }

        var style = getComputedStyle(optsContainer);
        var gapMobile = parseInt(style.getPropertyValue('--new-hcs-gap-mobile'), 10) || 16;
        var gapTablet = parseInt(style.getPropertyValue('--new-hcs-gap-tablet'), 10) || 16;
        var gapDesktop = parseInt(style.getPropertyValue('--new-hcs-gap-desktop'), 10) || 16;
        var spm = parseFloat(style.getPropertyValue('--new-hcs-slides-mobile')) || 1;
        var spt = parseFloat(style.getPropertyValue('--new-hcs-slides-tablet')) || 2;
        var spd = parseFloat(style.getPropertyValue('--new-hcs-slides-desktop')) || 4;

        if (spm < 0.1) spm = 1;
        if (spt < 0.1) spt = 2;
        if (spd < 0.1) spd = 4;
        if (gapMobile < 0) gapMobile = 0;
        if (gapTablet < 0) gapTablet = 0;
        if (gapDesktop < 0) gapDesktop = 0;

        /* Stage padding: se "Rimuovi padding destro" è attivo, lo slider ha solo padding-left (20px mobile / 35px desktop, vedi new-home-collection-swiper.liquid). slidesOffsetAfter replica lo stesso valore sul lato destro per evitare che l'ultima slide tocchi il bordo viewport. Pattern allineato a home-product-slider / new-home-media-slider / product-recommendation-slider. */
        var sectionEl = optsContainer.closest('section[id^="new-hcs-"]');
        var hasMobileRightPaddingRemoved = sectionEl && sectionEl.getAttribute('data-remove-right-padding-mobile') === 'true';
        var hasDesktopRightPaddingRemoved = sectionEl && sectionEl.getAttribute('data-remove-right-padding-desktop') === 'true';
        var offsetAfterMobile = hasMobileRightPaddingRemoved ? 20 : 0;
        var offsetAfterDesktop = hasDesktopRightPaddingRemoved ? 35 : 0;

        base.spaceBetween = gapMobile;
        base.slidesPerView = spm;
        base.slidesOffsetAfter = offsetAfterMobile;
        base.breakpoints = {
          768: {
            slidesPerView: spt,
            spaceBetween: gapTablet,
            slidesOffsetAfter: offsetAfterDesktop
          },
          992: {
            slidesPerView: spd,
            spaceBetween: gapDesktop,
            slidesOffsetAfter: offsetAfterDesktop
          }
        };

        if (prefersReducedMotion && extra.autoplay) {
          extra.autoplay = false;
        }

        var wrapper = node.querySelector('.swiper-wrapper');
        var slides = wrapper ? wrapper.querySelectorAll('.swiper-slide') : [];
        var realSlideCount = slides.length;

        if (extra.pagination) {
          var paginationEl = optsContainer.querySelector('.swiper-pagination');
          if (paginationEl) {
            base.pagination = {
              el: paginationEl,
              clickable: true,
              bulletClass: 'swiper-pagination-bullet',
              bulletActiveClass: 'swiper-pagination-bullet-active'
            };
          }
        }

        var section = optsContainer.closest('section[id^="new-hcs-"]');
        if (section && typeof extra.hide_arrows_mobile === 'boolean') {
          if (extra.hide_arrows_mobile === true) {
            section.setAttribute('data-hide-arrows-mobile', 'true');
            section.classList.add('new-hcs-hide-arrows-mobile');
          } else {
            section.removeAttribute('data-hide-arrows-mobile');
            section.classList.remove('new-hcs-hide-arrows-mobile');
          }
        }
        var hideArrowsMobile = section && section.getAttribute('data-hide-arrows-mobile') === 'true';
        var isMobile = window.matchMedia('(max-width: 767px)').matches;
        var useNavigation = extra.navigation && (!hideArrowsMobile || !isMobile);
        var nextEl = optsContainer.querySelector('.swiper-button-next') || (section && section.querySelector('.section-header-tokens__nav .swiper-button-next'));
        var prevEl = optsContainer.querySelector('.swiper-button-prev') || (section && section.querySelector('.section-header-tokens__nav .swiper-button-prev'));
        if (useNavigation && nextEl && prevEl) {
          base.navigation = {
            nextEl: nextEl,
            prevEl: prevEl,
            disabledClass: 'swiper-button-disabled'
          };
        }

        if (extra.loop) {
          base.loop = true;
          if (realSlideCount > 0) base.loopedSlides = realSlideCount;
        }
        if (extra.autoplay) base.autoplay = extra.autoplay;

        var swiper = new Swiper(node, base);
        node.newHcSwiper = swiper;

        if (section && section.classList.contains('new-hcs-nav-in-header') && useNavigation) {
          var headerNext = section.querySelector('.section-header-tokens__nav .swiper-button-next');
          var headerPrev = section.querySelector('.section-header-tokens__nav .swiper-button-prev');
          if (headerNext && headerPrev && (headerNext !== nextEl || headerPrev !== prevEl)) {
            headerNext.addEventListener('click', function() { swiper.slideNext(); });
            headerPrev.addEventListener('click', function() { swiper.slidePrev(); });
            function syncHeaderDisabled() {
              headerPrev.classList.toggle('swiper-button-disabled', swiper.isBeginning);
              headerNext.classList.toggle('swiper-button-disabled', swiper.isEnd);
            }
            syncHeaderDisabled();
            swiper.on('slideChangeTransitionEnd', syncHeaderDisabled);
            swiper.on('init', syncHeaderDisabled);
          }
        }

        if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
          var section = optsContainer.closest('[id^="new-hcs-"]');
          if (section && section.id) {
            var sectionIdFromDOM = section.id.replace('new-hcs-', '');
            document.addEventListener('shopify:section:unload', function unloadHandler(e) {
              if (e.detail.sectionId === sectionIdFromDOM) {
                if (swiper && swiper.destroy) {
                  swiper.destroy(true, true);
                  node.newHcSwiper = null;
                }
                document.removeEventListener('shopify:section:unload', unloadHandler);
              }
            });
          }
        }

      } catch(e) {
        console.error('[New HCS] Errore init Swiper', e);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewHCSwiper);
  } else {
    initNewHCSwiper();
  }

  if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initNewHCSwiper);
  }
})();
